import { render, staticRenderFns } from "./ManageFolderModal.vue?vue&type=template&id=1b0857b6&scoped=true"
import script from "./ManageFolderModal.vue?vue&type=script&lang=js"
export * from "./ManageFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0857b6",
  null
  
)

export default component.exports